import { Link } from 'react-router-dom';
import { Heart, ExternalLink, Twitter } from 'lucide-react';

const MOCGA_LOGO = 'https://customer-assets.emergentagent.com/job_councillor-watch/artifacts/4ea27emo_Fashion%20Retailer%20Logo%20-%20mocga.uk_20251201_030015_0000.png';
const WATCHTOWER_LOGO = 'https://static.prod-images.emergentagent.com/jobs/17b3d771-b1f5-4098-a241-9e4a23cb7105/images/d723499229a122d3a5167c0be3fe90a0120654740a7a8849a0415df0e44449c8.png';
const X_HANDLE = 'TheWatchtowerPo';

export const Footer = () => {
  return (
    <footer className="footer-massive" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-16">
          {/* About */}
          <div>
            <h3 className="text-sm font-medium tracking-wide uppercase mb-4 text-slate-400">About</h3>
            <p className="text-slate-400 text-sm leading-relaxed">
              An independent platform dedicated to political accountability and transparency in the UK. 
              We aggregate news and accept anonymous tips to shine a light on misconduct.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-sm font-medium tracking-wide uppercase mb-4 text-slate-400">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-slate-300 hover:text-white text-sm link-underline">
                  Latest News
                </Link>
              </li>
              <li>
                <Link to="/compare" className="text-slate-300 hover:text-white text-sm link-underline">
                  Party Comparison
                </Link>
              </li>
              <li>
                <Link to="/submit-tip" className="text-slate-300 hover:text-white text-sm link-underline">
                  Submit a Tip
                </Link>
              </li>
              <li>
                <Link to="/search" className="text-slate-300 hover:text-white text-sm link-underline">
                  Search Archive
                </Link>
              </li>
            </ul>
          </div>

          {/* Support */}
          <div>
            <h3 className="text-sm font-medium tracking-wide uppercase mb-4 text-slate-400">Support Us</h3>
            <p className="text-slate-400 text-sm leading-relaxed mb-4">
              Help fund independent journalism and political accountability.
            </p>
            <Link 
              to="/donate" 
              className="inline-flex items-center space-x-2 bg-red-600 text-white px-4 py-2 text-xs font-medium tracking-wide uppercase hover:bg-red-700"
              data-testid="footer-donate"
            >
              <Heart className="h-4 w-4" />
              <span>Donate Now</span>
            </Link>
          </div>

          {/* Shop MOCGA */}
          <div>
            <h3 className="text-sm font-medium tracking-wide uppercase mb-4 text-slate-400">Shop</h3>
            <a 
              href="https://www.mocga.uk" 
              target="_blank" 
              rel="noopener noreferrer"
              className="block mb-4"
            >
              <img 
                src={MOCGA_LOGO} 
                alt="MOCGA" 
                className="h-12 object-contain opacity-80 hover:opacity-100 transition-opacity"
              />
            </a>
            <p className="text-slate-400 text-sm leading-relaxed mb-4">
              Premium British streetwear. Fashion with a purpose.
            </p>
            <a 
              href="https://www.mocga.uk" 
              target="_blank" 
              rel="noopener noreferrer"
              className="inline-flex items-center space-x-2 text-slate-300 hover:text-white text-sm"
            >
              <span>Shop Now</span>
              <ExternalLink className="h-3 w-3" />
            </a>
          </div>
        </div>

        {/* Massive Title */}
        <div className="border-t border-slate-800 pt-12">
          <div className="flex items-center justify-between flex-wrap gap-4 mb-4">
            <div className="flex items-center space-x-4">
              <img src={WATCHTOWER_LOGO} alt="The Watchtower" className="h-12 w-12 object-contain invert" />
            </div>
            {/* Social Links */}
            <div className="flex items-center space-x-4">
              <a 
                href={`https://x.com/${X_HANDLE}`}
                target="_blank" 
                rel="noopener noreferrer"
                className="flex items-center space-x-2 bg-slate-800 hover:bg-slate-700 text-white px-4 py-2 transition-colors"
                data-testid="footer-x-link"
              >
                <Twitter className="h-4 w-4" />
                <span className="text-sm font-medium">@{X_HANDLE}</span>
              </a>
            </div>
          </div>
          <h2 className="footer-title text-white">
            The Watchtower
          </h2>
          <p className="text-slate-500 text-sm mt-4 font-mono">
            Independent • Objective • Uncompromising
          </p>
          <div className="flex items-center justify-between flex-wrap gap-4 mt-8">
            <p className="text-slate-600 text-xs font-mono">
              &copy; {new Date().getFullYear()} The Watchtower. All rights reserved.
            </p>
            <a 
              href={`https://x.com/${X_HANDLE}`}
              target="_blank" 
              rel="noopener noreferrer"
              className="text-slate-500 hover:text-white text-xs font-mono flex items-center space-x-1"
            >
              <span>Follow us on X</span>
              <ExternalLink className="h-3 w-3" />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
